import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import Modal from '@hellodarwin/core/lib/components/common/hd-modal';
import InputNumber from '@hellodarwin/core/lib/components/common/input-number';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { ProgramClientRefusalReason, } from '@hellodarwin/core/lib/features/entities/programs-entities';
import theme from '@hellodarwin/core/lib/theme';
import Close from '@hellodarwin/icons/dist/icons/Close';
import Edit from '@hellodarwin/icons/dist/icons/Edit';
import DatePicker from 'antd/es/date-picker';
import Form from 'antd/es/form';
import FormItem from 'antd/es/form/FormItem';
import Radio from 'antd/es/radio';
import Select from 'antd/es/select';
import dayjs from 'dayjs';
import { t } from 'i18next';
import { useEffect } from 'react';
import { ModalActions, ModalContainer } from './styles';
const StepsManagerModal = ({ open, onClose, onConfirm, neededProperties, }) => {
    var _a, _b;
    const [form] = Form.useForm();
    const isAccepted = Form.useWatch('is_accepted', form);
    const modalForm = (_jsxs(Form, { form: form, layout: "vertical", initialValues: {
            program_targeted_amount: neededProperties.draft_first_version.amount,
            program_application_amount: neededProperties.submit_application.amount,
            program_accepted_amount: neededProperties.decisions_made.amount,
            program_applied_at: neededProperties.submit_application.time !== null
                ? (_a = neededProperties.submit_application.time) === null || _a === void 0 ? void 0 : _a.toDate()
                : undefined,
            program_result_at: neededProperties.decisions_made.time !== null
                ? (_b = neededProperties.decisions_made.time) === null || _b === void 0 ? void 0 : _b.toDate()
                : undefined,
            program_refusal_reason: neededProperties.decisions_made.refusal_reason !== null
                ? neededProperties.decisions_made.refusal_reason
                : undefined,
            is_accepted: !neededProperties.decisions_made.refusal_reason,
        }, onFinish: (values) => {
            onConfirm(values);
        }, style: { width: '100%', margin: 0, gap: 16 }, children: [neededProperties.draft_first_version.amount !== null && (_jsx(FormItem, { name: "program_targeted_amount", label: _jsx(Typography, { elementTheme: "h5", children: t(`application|targeted_amount`) }), rules: [
                    {
                        required: true,
                        message: t('application_single|required_amount'),
                    },
                ], children: _jsx(InputNumber, { min: 0, style: { maxWidth: '180px', width: '100%' } }) })), neededProperties.submit_application.time !== null && (_jsx(FormItem, { name: "program_applied_at", label: _jsx(Typography, { elementTheme: "h5", children: t(`application|applied_at`) }), rules: [
                    {
                        required: true,
                        message: t('application_single|required_date'),
                    },
                ], getValueProps: (value) => ({
                    value: value ? dayjs(value) : null,
                }), children: _jsx(DatePicker, {}) })), neededProperties.submit_application.amount !== null && (_jsx(FormItem, { name: "program_application_amount", label: _jsx(Typography, { elementTheme: "h5", children: t(`application|applied_amount`) }), rules: [
                    {
                        required: true,
                        message: t('application_single|required_amount'),
                    },
                ], children: _jsx(InputNumber, { min: 0, style: { maxWidth: '180px', width: '100%' } }) })), neededProperties.decisions_made.time !== null && (_jsx(FormItem, { name: "program_result_at", label: _jsx(Typography, { elementTheme: "h5", children: t(`application_single|application_result_at`) }), rules: [
                    {
                        required: true,
                        message: t('application_single|required_date'),
                    },
                ], getValueProps: (value) => ({
                    value: value ? dayjs(value) : null,
                }), children: _jsx(DatePicker, {}) })), neededProperties.decisions_made.refusal_reason !== null && (_jsx(FormItem, { name: "is_accepted", label: _jsx(Typography, { elementTheme: "h5", children: t(`application|result`) }), rules: [
                    {
                        required: true,
                    },
                ], children: _jsxs(Radio.Group, { children: [_jsx(Radio, { value: true, children: t('application|accepted') }), _jsx(Radio, { value: false, children: t('application|refused') })] }) })), ((neededProperties.decisions_made.refusal_reason === null &&
                neededProperties.decisions_made.amount !== null) ||
                (isAccepted && neededProperties.decisions_made.amount !== null)) && (_jsx(FormItem, { name: "program_accepted_amount", preserve: false, label: _jsx(Typography, { elementTheme: "h5", children: t(`application|accepted_amount`) }), rules: [
                    {
                        required: true,
                        message: t('application_single|required_amount'),
                    },
                ], children: _jsx(InputNumber, { min: 0, style: { maxWidth: '180px', width: '100%' } }) })), !isAccepted &&
                neededProperties.decisions_made.refusal_reason !== null && (_jsx(Form.Item, { name: "program_refusal_reason", preserve: false, label: _jsx(Typography, { elementTheme: "h5", children: t(`application|refusal_reason`) }), rules: [
                    {
                        required: true,
                        message: t('application|required_reason'),
                    },
                ], children: _jsx(Select, { options: Object.values(ProgramClientRefusalReason).map((value) => ({
                        value,
                        label: t(`application|${value}`),
                    })), popupMatchSelectWidth: true, style: { width: '100%' } }) }))] }));
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if (open) {
            form.resetFields();
            form.setFieldsValue({
                program_targeted_amount: (_a = neededProperties.draft_first_version.amount) !== null && _a !== void 0 ? _a : undefined,
                program_application_amount: (_b = neededProperties.submit_application.amount) !== null && _b !== void 0 ? _b : undefined,
                program_accepted_amount: (_c = neededProperties.decisions_made.amount) !== null && _c !== void 0 ? _c : undefined,
                program_applied_at: neededProperties.submit_application.time !== null
                    ? (_d = neededProperties.submit_application.time) === null || _d === void 0 ? void 0 : _d.toDate()
                    : undefined,
                program_result_at: neededProperties.decisions_made.time !== null
                    ? (_e = neededProperties.decisions_made.time) === null || _e === void 0 ? void 0 : _e.toDate()
                    : undefined,
                program_refusal_reason: (_f = neededProperties.decisions_made.refusal_reason) !== null && _f !== void 0 ? _f : undefined,
                is_accepted: !neededProperties.decisions_made.refusal_reason,
            });
        }
    }, [open, neededProperties, form]);
    return (_jsx(Modal, { header: _jsx(ModalContainer, { children: _jsx(Typography, { elementTheme: "h5", textAlign: "center", children: t('application|confirm_application_amounts') }) }), open: open, handleCancel: onClose, styles: {
            content: {
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                minHeight: '0px',
                height: 'auto',
            },
            container: {
                width: 'fit-content',
                height: 'fit-content',
            },
            body: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                justifyContent: 'center',
                paddingLeft: '24px',
                paddingRight: '24px',
                paddingTop: '16px',
            },
        }, footer: _jsxs(ModalActions, { children: [_jsx(Button, { size: "small", defaultStyle: theme.colors.white_1, headingIcon: _jsx(Close, { size: 16 }), onClick: onClose, children: t('button|cancel') }), _jsx(Button, { size: "small", defaultStyle: theme.colors.purple_1, headingIcon: _jsx(Edit, { size: 16 }), onClick: form.submit, children: t('button|save') })] }), children: modalForm }));
};
export default StepsManagerModal;
